import { render, staticRenderFns } from "./EmailProviderTariff.vue?vue&type=template&id=6521b976&"
import script from "./EmailProviderTariff.vue?vue&type=script&lang=ts&"
export * from "./EmailProviderTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports